import { PaStatus, PaStatusLabels } from "../enums/paStatus";
import { PocAssignee, PocAssigneeLabels } from "../enums/pocAssignee";
import { RouteVia, RouteViaLabels } from "../enums/routeVia";
import { BadgeOption } from "./submissionSummaryOptions";

export const PRIMARY_CARE_OUTCOME_OPTIONS: BadgeOption[] = [
  {
    id: PaStatus.APPROVED,
    text: PaStatusLabels[PaStatus.APPROVED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.DENIED,
    text: PaStatusLabels[PaStatus.DENIED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.PENDING,
    text: PaStatusLabels[PaStatus.PENDING],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.AUTH_NOT_REQUIRED,
    text: PaStatusLabels[PaStatus.AUTH_NOT_REQUIRED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.NA_OUTCOME,
    text: PaStatusLabels[PaStatus.NA_OUTCOME],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.ONSHORE_ASSISTANCE,
    text: PaStatusLabels[PaStatus.ONSHORE_ASSISTANCE],
    textColor: "black",
    bgColor: "white",
  },
];

export const PRIMARY_CARE_ROUTE_VIA_OPTIONS: BadgeOption[] = [
  {
    id: RouteVia.CMM,
    text: RouteViaLabels[RouteVia.CMM],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.FAXPA,
    text: "Fax",
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.PHONEPA,
    text: "Phone PA",
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.PROMPTPA,
    text: "Prompt PA",
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.SURESCRIPTS,
    text: "SureScripts",
    textColor: "black",
    bgColor: "white",
  },
];

export const PRIMARY_CARE_POC_OPTIONS: BadgeOption[] = [
  {
    id: PocAssignee.AAMER,
    text: PocAssigneeLabels[PocAssignee.AAMER],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PocAssignee.SADIA,
    text: PocAssigneeLabels[PocAssignee.SADIA],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PocAssignee.SANA,
    text: PocAssigneeLabels[PocAssignee.SANA],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PocAssignee.AZMATH,
    text: PocAssigneeLabels[PocAssignee.AZMATH],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PocAssignee.ANKIT,
    text: PocAssigneeLabels[PocAssignee.ANKIT],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PocAssignee.RACHA,
    text: PocAssigneeLabels[PocAssignee.RACHA],
    textColor: "black",
    bgColor: "white",
  },
];
